module.exports = __webpack_public_path__ + "nunito-sans-latin-300.e7a891b0ad0ce9050b19e3d0cdfcd860.woff";